module.exports = __webpack_public_path__ + "static/img/__8360.1c8e6f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8360.jpg
// module id = A50l
// module chunks = 0